import { eksmoBP } from 'Lib/bp/bp';
import { onScreen } from 'Lib/on-screen/on-screen';
import { loadSrcOrBg } from 'Lib/load-src-or-bg/load-src-or-bg';
import { getW } from 'Lib/w/w';

const $insert = $('.text-insert-article');

$insert.each(function () {
    const $thisInsert = $(this);
    const $p = $thisInsert.closest('p');

    if ($p.length) {
        if (getW() > eksmoBP.xsMax) {
            $thisInsert.prependTo($p);
        } else {
            $thisInsert.appendTo($p);
        }
    }
});

onScreen($insert.find('.text-insert-article__pic'), loadSrcOrBg);